import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addFlexibleSpec, changeFlexibleSpecValue, getReachEstimate, removeSpecItem, removeExclusionItem, removeFlexibleSpecChunk } from 'redux/modules/audience';
import * as _ from 'lodash';
import Chip from 'material-ui/Chip';
import AudienceBehaviors from './AudienceBehaviors';
import AudienceInterests from './AudienceInterests';
import AudienceDemographics from './AudienceDemographics';
import * as styles from './Audiences.scss';
var AccordionTargetingRow = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    audience: state.audience,
    flexibleSpec: state.audience.FacebookTargetingConfig.data.flexible_spec,
    exclusions: state.audience.FacebookTargetingConfig.data.exclusions
  };
}, {
  addFlexibleSpec: addFlexibleSpec,
  changeFlexibleSpecValue: changeFlexibleSpecValue,
  getReachEstimate: getReachEstimate,
  removeFlexibleSpecChunk: removeFlexibleSpecChunk,
  removeSpecItem: removeSpecItem,
  removeExclusionItem: removeExclusionItem
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AccordionTargetingRow, _Component);

  var _super = _createSuper(AccordionTargetingRow);

  function AccordionTargetingRow(props) {
    var _this;

    _classCallCheck(this, AccordionTargetingRow);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleChipDelete", function (chip, chunkIndex, chunkKey, isExclusion) {
      isExclusion ? _this.props.removeExclusionItem(chip) : _this.props.removeSpecItem(chunkKey, chip, chunkIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "handleExclude", function () {
      _this.props.addFlexibleSpec(true);
    });

    _defineProperty(_assertThisInitialized(_this), "handleNarrow", function () {
      _this.props.addFlexibleSpec();
    });

    _defineProperty(_assertThisInitialized(_this), "renderSpecChunk", function (targetChunk, index) {
      var isExclusion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var header = isExclusion ? 'EXCLUDE people who match at least ONE of the following:' : index === 0 ? 'INCLUDE people who match at least ONE of the following:' : 'and MUST ALSO match at least ONE of the following:';
      return /*#__PURE__*/React.createElement("div", {
        style: {
          margin: '24px 0'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.targetingRowHeader
      }, header, index !== 0 && /*#__PURE__*/React.createElement("i", {
        onClick: function onClick() {
          _this.props.removeFlexibleSpecChunk(index);
        },
        className: "".concat(styles.closeIcon, " icon ion-ios-close-outline")
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.targetingRowSpecWrap,
        key: "renderSpecChunk_".concat(index)
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(AudienceInterests, {
        specIndex: index,
        isExclusion: isExclusion
      }), /*#__PURE__*/React.createElement(AudienceDemographics, {
        specIndex: index,
        isExclusion: isExclusion
      }), /*#__PURE__*/React.createElement(AudienceBehaviors, {
        specIndex: index,
        isExclusion: isExclusion
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          marginTop: 16
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexWrap: 'wrap'
        }
      }, _this.renderIncludedChips(targetChunk, index, isExclusion))))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderIncludedChips", function (chunk, chunkIndex, isExclusion) {
      var chips = [];

      if (chunk) {
        Object.keys(chunk).map(function (chunkKey, index) {
          if (chunk[chunkKey].length) {
            var chunkChips = chunk[chunkKey].map(function (c, cIndex) {
              var name = c.name;

              if (chunkKey === 'education_statuses') {
                name = _this.state.educationOptions.find(function (o) {
                  return parseInt(o.id) === parseInt(c);
                }).name;
              }

              if (chunkKey === 'relationship_statuses') {
                name = _this.state.relationshipOptions.find(function (o) {
                  return parseInt(o.id) === parseInt(c);
                }).name;
              }

              return /*#__PURE__*/React.createElement(Chip, {
                style: {
                  marginBottom: 6,
                  marginRight: 6
                },
                onRequestDelete: function onRequestDelete() {
                  return _this.handleChipDelete(c, chunkIndex, chunkKey, isExclusion);
                },
                key: cIndex
              }, name);
            });
            chips.push(chunkChips);
          }
        });
      }

      return chips;
    });

    _this.state = {
      educationOptions: [{
        id: '6',
        name: 'Associate degree',
        type: 'education_statuses'
      }, {
        id: '3',
        name: 'College grad',
        type: 'education_statuses'
      }, {
        id: '11',
        name: 'Doctorate degree',
        type: 'education_statuses'
      }, {
        id: '4',
        name: 'High school grad',
        type: 'education_statuses'
      }, {
        id: '2',
        name: 'In college',
        type: 'education_statuses'
      }, {
        id: '7',
        name: 'In grad school',
        type: 'education_statuses'
      }, {
        id: '1',
        name: 'In high school',
        type: 'education_statuses'
      }, {
        id: '9',
        name: "Master's degree",
        type: 'education_statuses'
      }, {
        id: '10',
        name: 'Professional degree',
        type: 'education_statuses'
      }, {
        id: '5',
        name: 'Some college',
        type: 'education_statuses'
      }, {
        id: '8',
        name: 'Some grad school',
        type: 'education_statuses'
      }, {
        id: '13',
        name: 'Some high school',
        type: 'education_statuses'
      }, {
        id: '12',
        name: 'Unspecified',
        type: 'education_statuses'
      }],
      relationshipOptions: [{
        id: '7',
        name: 'Civil Union',
        type: 'relationship_statuses'
      }, {
        id: '10',
        name: 'Complicated',
        type: 'relationship_statuses'
      }, {
        id: '12',
        name: 'Divorced',
        type: 'relationship_statuses'
      }, {
        id: '8',
        name: 'Domestic Partnership'
      }, {
        id: '4',
        name: 'Engaged',
        type: 'relationship_statuses'
      }, {
        id: '2',
        name: 'In a relationship',
        type: 'relationship_statuses'
      }, {
        id: '3',
        name: 'Married',
        type: 'relationship_statuses'
      }, {
        id: '9',
        name: 'Open Relationship',
        type: 'relationship_statuses'
      }, {
        id: '11',
        name: 'Separated',
        type: 'relationship_statuses'
      }, {
        id: '1',
        name: 'Single',
        type: 'relationship_statuses'
      }, {
        id: '6',
        name: 'Unspecified',
        type: 'relationship_statuses'
      }, {
        id: '13',
        name: 'Widowed',
        type: 'relationship_statuses'
      }]
    };
    return _this;
  }

  _createClass(AccordionTargetingRow, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var exclusionsEmpty = _.isEmpty(this.props.exclusions);

      return /*#__PURE__*/React.createElement("div", null, this.props.flexibleSpec.map(function (spec, index) {
        return _this2.renderSpecChunk(spec, index);
      }), !exclusionsEmpty && this.renderSpecChunk(this.props.exclusions, 0, true), /*#__PURE__*/React.createElement("div", {
        className: styles.targetingRowHeader,
        style: {
          marginLeft: 12,
          display: 'block'
        }
      }, exclusionsEmpty && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
        onClick: this.handleExclude,
        className: styles.quietLink
      }, "Exclude People"), ' ', "or", ' '), /*#__PURE__*/React.createElement("span", {
        onClick: this.handleNarrow,
        className: styles.quietLink
      }, "Narrow ", this.props.flexibleSpec.length > 1 ? 'Further' : 'Audience')));
    }
  }]);

  return AccordionTargetingRow;
}(Component)) || _class);
export { AccordionTargetingRow as default };